const config = {
  production: "/backend",
  development: "https://test-api.controllergateway.com/",
  test: "http://localhost:8000/",
  documentation: "http://localhost:8000/",
};

export default config;
